import { useDispatch, useSelector } from "react-redux";

import { AwardsForm } from "./AwardsForm";
import { CreateAward } from "../../redux/awards";
import { ErrorBanner } from "../../components/banner";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { useNavigate } from "react-router-dom";

export const AwardsCreate = () => {
  const dispatch = useDispatch();
  const { error, loading } = useSelector((state) => state.awards);
  const navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to add this award`)) {
      dispatch(CreateAward(values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/about/awards");
      }, 500);
    }
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <Section>
      {error && <ErrorBanner text={error} />}
      <AwardsForm onFormSubmit={onFormSubmit} />
    </Section>
  );
};
